module.exports = __webpack_public_path__ + "img/葫芦娃.e2412a92.png";